import { render, staticRenderFns } from "./HistoryCurrentService.vue?vue&type=template&id=bc4853c8&scoped=true"
import script from "./HistoryCurrentService.vue?vue&type=script&lang=js"
export * from "./HistoryCurrentService.vue?vue&type=script&lang=js"
import style0 from "./HistoryCurrentService.vue?vue&type=style&index=0&id=bc4853c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc4853c8",
  null
  
)

export default component.exports